import React from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { PersonModel } from '../../models/personModel';
import { getGender, getAge } from '../../utils/personUtils';
import { convertToCustomDateFormat } from '../../utils/dateUtils';
import { getCountryNameFromIsoCode } from '../../utils/countryUtils';

interface Props {
  official?: PersonModel;
}

export function OfficialInformationTable(props: Props) {
  const { official } = props;
  const { t } = useTranslation();

  return (
    <table className='oit_officialInformation'>
      <thead>
        <tr>
          <th colSpan={2}>{t('information')}</th>
        </tr>
      </thead>
      <tbody>
        <tr className='oit_spacer' />
        <tr>
          <td className='oit_key_col'>{t('first_name')}</td>
          <td className='oit_val_col'>{official?.preferredGivenName}</td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('last_name')}</td>
          <td className='oit_val_col'>{official?.preferredFamilyName}</td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('nationality')}</td>
          <td className='oit_val_col'>
            {t(getCountryNameFromIsoCode(official?.nationalityCode) || '')}
          </td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('gender')}</td>
          <td className='oit_val_col'>{official?.genderCode && getGender(official.genderCode)}</td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('date_of_birth')}</td>
          <td className='oit_val_col'>
            {official?.birthDate && convertToCustomDateFormat(official?.birthDate, 'DD.MM.YYYY')}
          </td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('age')}</td>
          <td className='oit_val_col'>{official?.birthDate && getAge(official.birthDate)}</td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('country')}</td>
          <td className='oit_val_col'>
            {t(getCountryNameFromIsoCode(official?.residence?.country) || '')}
          </td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('city')}</td>
          <td className='oit_val_col'>{official?.residence?.city}</td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('zip')}</td>
          <td className='oit_val_col'>{official?.residence?.zip}</td>
        </tr>
        <tr>
          <td className='oit_key_col'>{t('address')}</td>
          <td className='oit_val_col'>{official?.residence?.address}</td>
        </tr>
      </tbody>
    </table>
  );
}
